import theme from 'config/theme';
import Icon, { IconNames } from 'components/Icon';
import { Container } from './styled';

export const WhatsappButton = () => {
  const msg = 'Buenas tardes, me gustaria recibir informacion respecto a la página';
  const whatsappURL = `https://wa.me/+5491159512300?text=${msg}`;

  return (
    <Container
      onClick={() => {
        window.open(whatsappURL, '_blank');
      }}
    >
      <Icon name={IconNames.Whatsapp} size={30} color={theme.colors.white} />
    </Container>
  );
};
